import { takeEvery, call, put } from 'redux-saga/effects';
import {
  sendRequest,
  requestInProcess,
  requestFinished,
  clearAllErrors,
  initState
} from './participateContestForm';

import { dataRequest as requestContestsCollection } from '../../../../../../common/reducers/objectCollection/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import ContestsService from '../../../../services/ContestsService';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';
import { sendGetAuthAccountDataRequest } from '../../../../../users/common/reducers/states/authAccount';

function* participateContestFormSaga(reducerName, action) {
  yield put(requestInProcess(reducerName));
  try {
    yield put(clearAllErrors(reducerName));

    const result = yield call(
      timeoutCall,
      ContestsService.sendParticipateContestById,
      action.payload
    );
    if (result) {
      if (result.status === 200) {
        yield put(initState(reducerName));
        yield put(sendGetAuthAccountDataRequest());
        // Обновляем конкурс в contestsCollection, чтобы отобразить участие в конкурсе.
        yield put(
          requestContestsCollection(
            'contests.collections.contestsCollection',
            action.payload
          )
        );
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: 'Вы приняли участие в конкурсе'
          })
        );
      }
    }
    yield put(
      requestFinished(reducerName, result.status, result.status === 200)
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
  yield put(requestFinished(reducerName));
}

export default function getSaga(reducerName) {
  return [
    takeEvery(
      sendRequest(reducerName).type,
      participateContestFormSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/contests/reducers/static/forms/participateContest/participateContestFormSaga.js